import React, { useEffect, useState } from "react";
import {
    Divider,
    Grid,
    IconButton,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Close } from "../../../LeftNav/SvgIcons";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import { useDispatch } from "react-redux";
import { contactsTypesActions } from "../../../../../store/contactTypes/contactTypesActions";
import { el } from "date-fns/locale";
import moment from "moment";


const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "20px",
    },
    paper: {
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 0px 6px 0px #00000040",
        borderRadius: "20px",
        width: "815px",
        '& .endUserChatWindowWrapper': {
            height: "600px"
        },
        '& .chatEditorSocial': {
            width: "100%",
            borderRadius: "0px 0px 20px 20px",
            padding: "20px",
        },
        '& .conversationFileUpload': {
            marginRight: "120px",
        },
        '& .chatEditor': {
            borderRadius: "0px 0px 20px 20px",
            padding: "20px",
            width: "100%",
        },
        '& .chatEditor i': {
            bottom: "20px",
            right: "20px",
        },
        '& .conv-attachment-icon': {
            right: "20%",
        },
        '& .conv-attachment-icon-social': {
            right: "20%",
        },
        '& .chatEditorSocial i': {
            bottom: "20px",
            right: "20px",
        }
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "2px solid #E2E5E9",
        padding: "23px 33px 23px 41px;",
        background: "#3699FF",
        borderTopRightRadius: "20px",
        borderTopLeftRadius: "20px",
    },
    customerTypo: {
        fontSize: "22px",
        fontFamily: "Roboto",
        fontWeight: 700,
        color: "#fff",
    },
    innerBody: {
        overflowY: "auto",
    },
    chooseCustomerHeading: {
        fontSize: "22px",
        fontFamily: "Roboto",
        fontWeight: 700,
        color: "#181C32",
    },
    text: {
        fontSize: "14px",
        fontWeight: 400,
        fontFamily: "Roboto",
        margin: "16px 0px",
        color: "#434D56",
    },
    content: {
        display: "flex",
        justifyContent: "space-between",
        padding: "13px 18px 17px 20px",
    },
    closIcon: {
        padding: "unset",
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    mainCustomerPricing: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
    },
    mainBody: {
        padding: "32px",
    },
    customReleaseFilter: {
        fontSize: "12px",
        "& .MuiOutlinedInput-input": {
            padding: "13px 12px 13px 30px !important",
        },
    },
    leadContent: {
        width: "100%",
        maxHeight:"400px",
        marginBottom: "15px",
        padding: "23px 33px 23px 41px;",
        overflowY:"auto",
    },
    tagsHeadings: {
        color: "#2d3339",
        fontSize: "14px",
        fontWeight: "500",
    },
    subject:{
     fontSize:"12px",
    },
    notFoundText: {
        textAlign: "center",
        opacity: 0.5,
        fontSize: "12px",
        fontWeight: 500,
        marginBottom:"10px",
    },
    createdDated: {
        fontSize: "12px",
        fontWeight: 400,
        color: "#b5b5c3",
    }
}));

export const LeadCompaignView = ({
    openPopup,
    setOpenPopup,
    setLoading,
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [campaignData , setCampaignData] = useState([]);
    const [isLoading , setIsLoading] = useState("Loading...")
    const onClose = () => {
        setOpenPopup(null);
        setCampaignData([]);
    };

    useEffect(() => {
        setIsLoading("Loading...")
        setLoading(true)
        if(openPopup?.id){
        dispatch(
            contactsTypesActions.onGetCompaignByLeadId(openPopup?.id)
        ).then(data => {
            setLoading(false);
            if (data?.data?.length && data?.success) {
                setCampaignData(data?.data);
                setIsLoading("Loading...")
            }else{
                setIsLoading("No Email Sent")
            }
        });}
        setLoading(false)
    }, [openPopup?.id]);

    return (
        <Grid>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openPopup}
                onClose={onClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={openPopup}>
                    <Grid container className={classes.paper}>
                        <Grid item xs={12} className={classes.header}>
                            <Typography className={classes.customerTypo}>{`${openPopup?.firstName} ${openPopup?.lastName}`}</Typography>
                            <IconButton className={classes.closIcon} onClick={onClose}>
                            <Close />
                            </IconButton>
                        </Grid>
                        <Grid className={classes.leadContent}>
                            {
                                campaignData.length > 0 ?
                                campaignData.map((camp)=>
                                <div>
                                    <h2 className={classes.tagsHeadings}> Subject : 
                                    <span className={classes.subject}> {camp?.subject ? camp?.subject : "--"} </span> </h2>  
                                   <span className={classes.createdDated}>{ moment(camp?.createdDate).format("MMMM DD, YYYY hh:mm A")} </span>
                                <div className='marketingContent'>
                                    <h2 className={classes.tagsHeadings}> Content </h2>
                                    { 
                                    camp?.body ?   
                                    <div className="floraEditor">
                                    <FroalaEditorView model={camp?.body} />
                                    </div> :
                                    <div className={classes.notFoundText}>No Content Added</div>
                                    }
                                </div>
                                <Divider />
                                </div>)
                                :
                                <div className={classes.notFoundText}>
                                    {isLoading}
                                </div>
                            }
                        </Grid>
                    </Grid>
                </Fade>
            </Modal>
        </Grid>
    );
};
